import { Box, List, ListItemButton, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const PropertyLabel = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    marginBottom: theme.spacing(1),
}));

export const PropertyBox = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    padding: theme.spacing(1.5),
    textAlign: 'left',
    borderRadius: 5,
    boxShadow: '0 0 2px rgb(0 0 0 / 40%)',
    height: '100%',
}));

export const PropertyList = styled(List)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    padding: 0,
}));

export const PropertyListItemButton = styled(ListItemButton)(({ theme, selected }) => ({
    background: 'rgba(0, 0, 0, 0.08) !important',
    maxHeight: 30,
    flex: 'auto',
    width: 'auto',
    marginRight: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    textAlign: 'center',
    maxWidth: 140,
    ...(selected && { background: theme.palette.primary.main + ' !important', color: '#fff !important' }),
}));
